import { Divider, ListItemIcon, ListItemText, Menu, MenuItem } from '@material-ui/core';
import { AccountCircleOutlined, WorkOffOutlined } from '@material-ui/icons';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { USER_SETTINGS_URL } from '../../const/routes';
import CommonLink from '../common/CommonLink';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { logout } from '../../actions/auth-actions';

const AppMenuAccount = React.forwardRef((props, ref) => {
  const { openFor, onClose, logout } = props;
  return (
    <Menu
      ref={ref}
      open={!!openFor}
      anchorEl={openFor}
      getContentAnchorEl={null}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      onClose={onClose}
    >
      <CommonLink
        decorate={false}
        to={USER_SETTINGS_URL}
      >
        <MenuItem onClick={onClose}>
          <ListItemIcon>
            <AccountCircleOutlined />
          </ListItemIcon>
          <ListItemText
            primary={(
              <FormattedMessage
                id="menu.account.account"
                defaultMessage="Account"
              />
            )}
          />
        </MenuItem>
      </CommonLink>
      
      <Divider />
      
      <MenuItem
        onClick={event => {
          onClose(event);
          logout();
        }}
      >
        <ListItemIcon>
          <WorkOffOutlined />
        </ListItemIcon>
        <ListItemText
          primary={(
            <FormattedMessage
              id="menu.account.log.out"
              defaultMessage="Log out"
            />
          )}
        />
      </MenuItem>
    </Menu>
  );
});

const decorate = compose(
  connect(
    null,
    dispatch => bindActionCreators({ logout }, dispatch)),
);

export default decorate(AppMenuAccount);

